import { Place } from 'wdc-cube'

export const ParamIds = {
    compliance: 'compliance',
    resetPassword: 'rpwd',
    companyIds: 'companyIds',
    partnerIds: 'partnerId',
    personIds: 'personIds',
    tmRequestGroupId: 'tmgrid',
    tmMarkCacheId: 'tmmdci',
    taSelectedCard: 'tasc',
    grupoFormId: 'gfrmid',
    monitoramentoFormId: 'mfrmid',
    analiseFormId: 'afrmid',
    analiseSelectId: 'asrmid',
    regraFormId: 'rfrmid',
    condicaoFormId: 'cfrmid',
    borderoFormId: 'bdfrmid',
    borderoStatusProcId: 'bspdfrmid',
    resultadoShowOrigem: 'bdfrmresor',
    resultadoShowIdOrigem: 'bdfrmresorid',
    resultadoShowIdSacado: 'bdfrmressaid',
    resultVisaoCedenteId: 'rvcfrmid',
    borderoFiltroDataInicial: 'blfdi',
    borderoFiltroDataFinal: 'blfdf',
    borderoFiltroStatus: 'blfs',
    borderoFiltroCodBordero: 'blfcb',
    serasaHistoryStartDate: 'shsd',
    serasaHistoryEndDate: 'shed',
    serasaHistoryStatus: 'shst',
    serasaHistoryEndpoint: 'shep'
}

export const AttrIds = {
    parentSlot: 'parent-slot',
    dialogSlot: 'sialog-slot',
    newNpCondicaoAttr: 'new-np-condicao-attr',

    subscriptionsDetail_item: '0001'
}

export const Places = {
    main: Place.ROOT,
    pf: Place.UNKNOWN,
    pj: Place.UNKNOWN,
    serasaHistory: Place.UNKNOWN,
    serasa: Place.UNKNOWN,
    serpro: Place.UNKNOWN,
    grupo: Place.UNKNOWN,
    grupoForm: Place.UNKNOWN,
    analise: Place.UNKNOWN,
    analiseForm: Place.UNKNOWN,
    analiseSelect: Place.UNKNOWN,
    regraForm: Place.UNKNOWN,
    condicaoForm: Place.UNKNOWN,
    bordero: Place.UNKNOWN,
    borderoForm: Place.UNKNOWN,
    statusProcessamentoBordero: Place.UNKNOWN,
    resultadoAnalise: Place.UNKNOWN,
    resultadoDetalhadoAnalise: Place.UNKNOWN,
    dialogoResultadoDetalhadoAnalise: Place.UNKNOWN,
    integracaoMonitoramento: Place.UNKNOWN,
    integracaoMonitoramentoForm: Place.UNKNOWN,
    resultadoAnaliseVisaoCedente: Place.UNKNOWN,
    restricted: Place.UNKNOWN
}
